import { ProductEnvironmentSimpleAttribute } from "@hermes/api-model-product-environment";

import { ReplacePercentPipe } from "../pipe/replace-percent.pipe";

/**
 * Get the productAttribute data first value
 *
 * @param productAttribute agec product attribute
 * @returns undefined if no data value, data value otherwise
 */
export const getAttributeDataFirstValue = (
    attribute: ProductEnvironmentSimpleAttribute,
): string | undefined => attribute?.data && attribute.data[0];

/**
 * Replace the %s inside the productAttribute value with the productAttribute data first value if
 * it is greater than one
 *
 * @param productAttribute agec product attribute
 * @returns undefined if data value not greater than one, transformed value string with data value inside otherwise
 */
export const transformValueWithDataIfValueGreaterThanOne = (
    productAttribute: ProductEnvironmentSimpleAttribute,
): string | undefined => {
    const productAttributeData = getAttributeDataFirstValue(productAttribute);
    return !!productAttributeData &&
        Number.parseInt(productAttributeData, 10) >= 1
        ? new ReplacePercentPipe().transform(
              productAttribute.value,
              productAttributeData,
          )
        : undefined;
};

/**
 * Type guard to filter undefined, null, "" and 0 value
 */
export const filterUnwantedValue = <T>(
    x: T | false | undefined | null | "" | 0,
): x is T => !!x;
